import Vue from "vue";
import GoodList from "./Base/GoodList";
import List from "./Base/List";
import api from "../services/api";
import { Toast } from "vant";
Vue.use(Toast);
//无check逻辑
//无视图逻辑
class FirmOrder {
  debug = process.env.VUE_APP_DEV_DOMAIN === "true";

  loading = false;
  remark = "";
  list = new List([]);
  goodList = new GoodList({ list: this.list.list });

  form = ""; //购物车 buycar 来源还是立即下单

  constructor() {
    this.state = {
      list: this.list.list,
    };
  }

  updateList(list) {
    this.list.updateList(list);
    this.state.list = this.list.list;
    this.goodList.updateList(list);
    this.remark = "";
  }

  getSelectedLength() {
    return this.goodList.getSelectedLength.apply(this.goodList, arguments);
  }

  getSelectedAmount() {
    return this.goodList.getSelectedAmount.apply(this.goodList, arguments);
  }

  setForm(form) {
    this.form = form;
  }

  // 创建订单
  async createOrder({ AddressId, VehicleTypeId, WarehouseId, IsType }) {
    let { list } = this.state;

    this.loading = true;

    try {
      console.log("TotalAmount", this.getSelectedAmount());

      let data = JSON.parse(JSON.stringify(list));
      data.forEach(it => {
        delete it.list
        delete it.TyingProductInfo
      });
      //IsType:2为客户登录
      let _remark = '';
      if(IsType == 2){
        let contactsName = localStorage.getItem("contactsName") || '无';
        let contactsMobile = localStorage.getItem("contactsMobile") || '';
        _remark = '下单人：' +  contactsName + '；下单人手机号：' +  contactsMobile;
        if(this.remark != ''){
          _remark = this.remark + '\n' + '下单人：' +  contactsName + '；下单人手机号：' +  contactsMobile;
        }
      }
      let res = await api.CreatOrder({
        AddressId,
        VehicleTypeId,
        ProductDetails: JSON.stringify(data),
        TotalAmount: parseFloat(this.getSelectedAmount()).toFixed(2),
        WarehouseId: WarehouseId,
        Remark: _remark,
        IsType
      });

      if (res.ResultType == 1) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        return res.Data;
      } else {
        this.loading = false;
        Toast(res.Reason || "系统繁忙，下单失败，请您稍后再次尝试");
      }
    } catch (e) {
      this.loading = false;
      Toast(e || "系统繁忙，下单失败，请您稍后再次尝试");
    }
  }
}
export default new FirmOrder();
